var DATA_URI_PATTERN = /^data:(\S*?)?(;charset=[^;]+)?(;[^,]+?)?,(.+)/;

function isDataUriResource(uri) {
  return DATA_URI_PATTERN.test(uri);
}

module.exports = isDataUriResource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/utils/is-data-uri-resource.js
// module id = 738
// module chunks = 0 1